export enum SharedAnalyticsEvents {
  BlockNumber = 'blk_num',
  UnblockNumber = 'unblk_num',
}
